import { NavLink, Route, Routes, useNavigate } from "react-router-dom";
import { useTheme, usePins } from "./hooks";
import { agentById } from "./data";
import HomePage from "./pages/HomePage";
import ComparePage from "./pages/ComparePage";
import AgentPage from "./pages/AgentPage";
import CalculatorPage from "./pages/CalculatorPage";
import MatrixPage from "./pages/MatrixPage";
import CoveragePage from "./pages/CoveragePage";
import MethodologyPage from "./pages/MethodologyPage";

export default function App() {
  const [theme, toggleTheme] = useTheme();
  const pins = usePins();
  const navigate = useNavigate();

  return (
    <div className="app">
      <header className="header">
        <div className="container header-inner">
          <NavLink to="/" className="brand">
            <span className="dot" /> AgentCompare
          </NavLink>
          <nav className="nav">
            <NavLink to="/" end>Agents</NavLink>
            <NavLink to="/calculator">Shipping calculator</NavLink>
            <NavLink to="/matrix">Country matrix</NavLink>
            <NavLink to="/coverage">Data coverage</NavLink>
            <NavLink to="/methodology">Methodology</NavLink>
          </nav>
          <button className="icon-btn" onClick={toggleTheme} title="Toggle theme" aria-label="Toggle theme">
            {theme === "dark" ? "☀" : "☾"}
          </button>
        </div>
      </header>

      <main className="main">
        <div className="container">
          <Routes>
            <Route path="/" element={<HomePage pins={pins} />} />
            <Route path="/compare" element={<ComparePage />} />
            <Route path="/agent/:id" element={<AgentPage pins={pins} />} />
            <Route path="/calculator" element={<CalculatorPage />} />
            <Route path="/matrix" element={<MatrixPage />} />
            <Route path="/coverage" element={<CoveragePage />} />
            <Route path="/methodology" element={<MethodologyPage />} />
          </Routes>
        </div>
      </main>

      {pins.pins.length > 0 && (
        <div
          style={{
            position: "sticky", bottom: 0, zIndex: 40, borderTop: "1px solid var(--border)",
            background: "var(--surface)", boxShadow: "var(--shadow)",
          }}
        >
          <div className="container row tray-inner" style={{ height: 56, gap: 10 }}>
            <strong className="small">Compare tray</strong>
            <div className="row wrap grow" style={{ gap: 6 }}>
              {pins.pins.map((id) => (
                <span key={id} className="chip on">
                  {agentById.get(id)?.name ?? id}
                  <span role="button" style={{ cursor: "pointer" }} onClick={() => pins.toggle(id)} aria-label="Remove">×</span>
                </span>
              ))}
            </div>
            <button className="btn sm ghost" onClick={pins.clear}>Clear</button>
            <button
              className="btn sm primary"
              disabled={pins.pins.length < 2}
              onClick={() => navigate(`/compare?ids=${pins.pins.join(",")}`)}
            >
              Compare {pins.pins.length}
            </button>
          </div>
        </div>
      )}

      <footer className="footer">
        <div className="container">
          Deterministic shopping-agent comparison · shipping prices captured live from each agent’s
          own calculator (guest, no login) for a standard 5 kg reference parcel — 100% real, nothing
          modeled. Every value is source-tagged; unknowns are shown as “Unknown,” never guessed.
        </div>
      </footer>
    </div>
  );
}
